import React from "react";
import { Card } from "antd";
import Answer from "./Answer";

const Question = ({ number, question, answers, answerType, clear }) => {
  //Save the answer selecteds in the state of the component Questionnaire
  // const onAnswer = (answerSelecteds) => {
  //     onChange({
  //         questionId: question.key,
  //         answersSelecteds: answerSelecteds,
  //     });
  // };
  return (
    <Card className="question-card mt-4">
      <h6>
        {number == undefined ? "" : number + ". "}
        {question.value}
      </h6>
      <Answer
        answer={answers}
        answerType={answerType}
        question={question}
        clear={clear}
      />
    </Card>
  );
};

export default Question;
